<div class="spinner-container"><span class="fa fa-spinner fa-lg spinner-icon"></span> {{ text() }}</div>
